<template>
  <div :class="[id === 0 ? 'payment-modules-saheli payment-modules' : 'payment-modules']">
      <div class="w-100" style="height: 35px;"></div>
    <div class="infobox mb-3 d-flex flex-column">
        <div class="inner-infobox">
          <div class="title-image-box d-flex flex-row justify-content-end">

            <div class="title-box d-flex flex-column  justify-content-center w-100 text-center">
              <p>{{type}}</p>
              <h4>{{title}}</h4>
            </div>

            <div class="image-box d-flex flex-row image-box justify-content-end">
              <img :src="`https://kishoto.ir/dtr/approid/img/${image}`">
            </div>

          </div>

          <div class="description-box d-flex flex-row justify-content-around mt-3">
              <div class="desc-text align-items-start d-flex">توضیحات: </div>
              <div class="info-text" v-html="des"></div>
          </div>

          <div class="pricebox d-flex flex-row justify-content-start mt-5">
            <div class="price-text">قیمت بلیط:</div>
            <div class="price-value">{{price | toPersianCurrency("تومان",0)}}</div>
          </div>
        </div>
    </div>

    <div class="mainpaymentbox d-flex justify-content-end">
      <div class="paymentbox d-flex flex-column">
      <div class="inner-paymentbox">
        <p>مشخصات فردی</p>
        <div class="info-row d-flex flex-row justify-content-around">
          <input disabled type="text" :value="name" class="name">
          <input disabled type="text" :value="mobile" class="phone">
        </div>
        <div class="payment-text d-flex flex-column justify-content-center text-center mt-3">
          <p>مبلغ قابل پرداخت</p>
          <h2>{{price | toPersianCurrency("تومان",0)}}</h2>
        </div>

        <div class="payment-btn d-flex flex-row justify-content-center mb-2">
            <button class="btn online-btn" @click="payment(0)">درگاه آنلاین بانک</button>
            <button class="btn wallet-btn" @click="payment(1)">پرداخت از کیف پول</button>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";

export default {
  data() {
    return {
      id:null,
      type:null,
      title:null,
      des:null,
      image:null,
      price:null,

      name:null,
      mobile:null,
    };
  },
  created(){
    this.getRouteParams();
    this.getProfile();
  },
  computed: {

  },
  methods: {
    getRouteParams(){
      if(this.$route.params.price){
        this.id = this.$route.params.id;
        this.type = this.$route.params.type;
        this.title = this.$route.params.title;
        this.des = this.$route.params.des;
        this.image = this.$route.params.image;
        this.price = this.$route.params.price;
      }else{
        this.$toast.open({
          message: 'اطلاعات به درستی دریافت نشد،به صفحه اصلی باز میگردید.',
          type: 'error',
        });

        setTimeout(()=>{
          this.$router.push("/");
        },2000);
      }
    },
    async getProfile() {
      let fd = new FormData();
      fd.append("token", store.state.login.loginTempToken);
      const response = await this.$ApiServiceLayer.post("get_profile", fd);

      if (response.status_code === 200){

        this.name = response.name;
        this.mobile = response.phone;

      }else if(response.status_code === 500){
        this.$toast.open({
          message: 'شما نیاز به ورود مجدد به برنامه دارید',
          type: 'error',
        });

        window.localStorage.removeItem("kishoto-store");
        window.localStorage.removeItem("token");


        setTimeout(()=>{
          this.$router.push("/login");
        },2000);
      }else{
        this.$toast.open({
          message: 'شما نیاز به ورود مجدد به برنامه دارید',
          type: 'error',
        });
        setTimeout(()=>{
          this.$router.push("/login");
        },2000);
      }
    },

   async payment(is_credit){
     this.$toast.open({
       message: 'لطفا تا ورود به درگاه منتظر باشید',
       type: 'info',
     });

      let fd = new FormData();
      fd.append("gid", this.id);
      fd.append("is_credit",is_credit);
      fd.append("token", store.state.login.loginTempToken);

      const response = await this.$ApiServiceLayer.post("games_payment", fd);
      console.log(response);

      if (response) {
        if(is_credit === 0){
        this.$toast.clear();
        this.$toast.open({
          message: 'به درگاه بانک منتقل میشوید',
          type: 'success',
        });

        this.loading = false;

        setTimeout(()=>{
          window.open(response.pay_url,'_self');
        },1000);
        console.log(response);

        }else{

          if(response.status_code === 200){
            this.$toast.open({
              message: "پرداخت شما با موفقیت انجام شد",
              type: 'success',
            });
          }
          if(response.status_code === 521){
            this.$toast.open({
              message: response.msg,
              type: 'error',
            });
          }

        }
      }
    }


  }
};
</script>

<style lang="scss" scoped>
.payment-modules-saheli{
  height: 100% !important;
  padding-bottom: 16px;
}
.payment-modules {
  width: 100%;
  direction: rtl;
  min-height: 100%;

  height: 100vh;
  background: rgb(156,39,176);
  background: linear-gradient(0deg, #9c27b0c2 10%, #d81b60de 30%, #ff1b69 77%);

  /*  background: url("~@/assets/img/bg/fifa_t_back.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;*/
  .infobox {
    background: #ffff;
    width: 93%;
    padding: 20px 0 20px 20px;
    border-radius: 30px 0px 0px 30px;
    .inner-infobox {
      padding: 3px 4px 0px 9px;
      border-left: 5px dotted gray;
      border-top: 5px dotted gray;
      border-bottom: 5px dotted gray;
      border-radius: 15px 0px 0px 15px;

      .title-image-box {
        .title-box {
          p {
            color: #455A64;
          }

          h4 {
            color:#455A64;
            font-size: 18px;
            font-weight: bold;
          }
        }

        .image-box {
          img {
            width: 100px;
            height: 100px;
          }
        }
      }
      .description-box{
        /*.desc-box{
              padding: 1px 8px 13px 14px;
              color: #757575;
              text-align: center;*/
          .desc-text {
            padding-left: 20px;
            padding: 1px 7px 13px 33px;
            color: #757575;
          }
        //}
        .info-text{
          color: #455A64;
          white-space: pre-line;
        }

      }
      .pricebox{
        .price-text{
          padding:1px 7px 13px 33px;
          color: #757575;
        }
        .price-value{
          color:#f44336;
          font-weight: bold;
          font-size: 15px;
        }
      }
    }
  }

  .mainpaymentbox{
    .paymentbox {
      background: #ffff;
      width: 93%;
      padding: 14px 14px 14px 0px;
      border-radius: 0px 30px 30px 0px;
      box-shadow: 4px 8px 7px 1px #80808061;
      .inner-paymentbox{
        padding: 15px 15px 0px 8px;
        border-right: 5px dotted gray;
        border-top: 5px dotted gray;
        border-bottom: 5px dotted gray;
        border-radius: 0px 15px 15px 0px;
        input{
          border-radius: 5px;
          border: 2px solid #9e9e9e;
          width: 47%;
          padding: 6px;
          color: #bdbdbd;
        }
        p{
          color: #455a64;
          font-size: 15px;
          font-weight: bold;
        }
        h2{
          color: #455a64;
          font-weight: bold;
        }
        .payment-btn{
          .btn{
            color:#ffffff;
            padding: 10px 12px 10px 10px;
            margin: 6px 9px 14px 6px;
            width: 100%;
            border-radius: 6px;
          }
          .online-btn{
            background:#536dfe;
          }
          .wallet-btn{
            background:#8bc34a;
          }
        }

      }
    }
  }

}
</style>
